<!--论文科报会-->
<template>
    <div class="gray-back" style="padding:.2rem 0 0 0 ; height: 100%">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
 
            <van-cell-group>
            <van-field name="radio" label="身份"
                       input-align="right">
                <template #input>
                    <van-radio-group v-model="formData.lunwen_type" direction="horizontal">
                        <van-radio checked-color="#ffb01b" name="本科生">本科生</van-radio>
                        <van-radio checked-color="#ffb01b" name="研究生">研究生</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <van-field
                    v-model="formData.lunwen_title"
                    label="论文题目"
                    :rules="[{ required: true, message: '不能为空' }]"
                    error-message-align="right"
                    input-align="right"
                    clearable
                    placeholder="请输入论文题目"
            /> 

            <van-cell title="上传大摘要"  >
                </van-cell>
                <div class="row">
                    <FileUploader uploadText="上传文件" :fileList="formData.lunwen_dazhaiyao" :limit="1" accept=".docx"
                                  :name="'lunwen_dazhaiyao'"></FileUploader>
                </div>
                <div class="operate-desc-left"  >要求：格式docx、字数不少于1000字</div>


            <van-cell title="上传论文文件"  >
                </van-cell>
                <div class="row">
                    <FileUploader uploadText="上传文件" :fileList="formData.lunwen_content" :limit="1" accept=".docx"
                                  :name="'lunwen_content'"></FileUploader>
                </div>
                <div class="operate-desc-left"   >要求：格式docx、字数不少于10000字</div>



            </van-cell-group>
            <div style="height: 100px"></div>

            <div class="savebtn">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">保存</van-button>
            </div>
        </van-form>

 

    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .memberResultWrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        padding: 0.2rem;
    }
    .memberResultWrap .memberLi{
        font-size: 14px;
        color: #666;
        height: 36px;
        line-height: 36px;
    }
    .memberResultWrap .memberLi .van-tag{
        width: auto !important;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }

</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Dialog,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';

    import SubjectJiaolianPicker from '@/components/picker/SubjectJiaolianPicker.vue';
    import YundongyuanPicker from '@/components/picker/YundongyuanPicker.vue';


    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button).use(Dialog);
    export default {
        name: 'HuiyiApplyFormStep2',
        components: {
            [Field.name]: Field,
            PicUploader,
            FileUploader,
        },
        data: function () {
            return {
                validator,
                playMusicUrl:'',
                thisMemberIndex:0,
                thisMemberField:'',
                saveLoading:false,
                showNumTypePicker:false,
                showShenbaoTypePicker:false,
                addShow:false,
                show_share_panel:false,
                numTypeColumns: ['身份证', '护照'],
                showArea:false,
                areaList:{},
                thismember:{
                },
                copy_text:'cccc',
                areaValue:'',
                submitType:'',
                shenbaoTypeColumns:[],
                row:{
                    id:0,
                    member_list:[],
                    service_options:[],
                    shenbaotype:[],
                },
                formData: {
                    lunwen_title:'',
                    lunwen_type:'',
                    lunwen_content:[],
                    lunwen_dazhaiyao:[],
                },
            }
        },
        filters: {},
        mounted() {
            document.title = '论文科报会信息补充';

            let that = this;
            that.areaList = area;
            that.row.id = this.$route.query.id;
            if(that.row.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        computed:{
//            shenbaoTypeColumns(){
//                return [];
                /*
                 this.row.service_options.map(item =>{
                 return item.name;
                 })
                 */
//            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            }, 
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                if(!that.formData.lunwen_type){
                    Toast.fail('请选择身份');
                    return;
                }
                that.formValidate = true;
                let valiOk = true;

                if(!valiOk){
                    return ;
                }

                that.saveLoading = true;

                that.$api.post('/api/huiyi/step10Save', that.formData, (res) => {
 
                    setTimeout(function () {
                        rbLink({
                            name:'HuiyiApplyFormStep5',
                            query:{
                                id: that.row.id
                            }
                        })
                    },50);
                    that.saveLoading = false;
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/huiyi/step10detail', {
                    id:that.row.id
                }, (res) => {
                    that.formData = res.data;  
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },


            shareWeixinFriend(){
                console.log('shareWeixinFriend')
                let that = this;
                if(window.isApp()){
                    appEvent({
                        name: 'shareWeixinFriend',
                        query: that.row.share_data
                    });
                }else{
                    this.showWxShare = true;
                    this.show_share_panel = false;
                }
            },
            shareWeixinTimeLine(){
                let that = this;
                if(window.isApp()){
                    appEvent({
                        name: 'shareWeixinTimeLine',
                        query: that.row.share_data
                    });
                }else{
                    this.showWxShare = true;
                    this.show_share_panel = false;

                }
            }

        }
    }
</script>



// WEBPACK FOOTER //
// HuiyiApplyFormStep10.vue?7e4d36be